module.exports = __webpack_public_path__ + "static/media/frutiger-45light.5b791590.svg";